
function programModelForm(name, fields) {
    module.directive(name, /* @ngInject */ function(ModelService) {
        return {
            restrict: 'E',
            templateUrl: 'programs/programModel/' + name,
            scope: {programModel: '='},
            require: '^basicForm',
            link: function(scope, element, attrs, basicForm) {
                scope.data = ModelService.copyFields(scope.programModel, fields);
                basicForm.data = scope.data;
                scope.form = basicForm.getForm();

                basicForm.save = function(data) {
                    return ModelService.patchModel(scope.programModel, data);
                };
            },
        };
    });
}

programModelForm('programModelEnrollmentForm', [
    'expected_enrollment', 'average_length', 'expected_attendance',
    'instructional_hours']);


programModelForm('programModelEducationForm', [
    'educational_component_provider', 'diploma_granting',
    'diploma_grantor', 'diploma_grantor_other', 'charter_source',
    'diploma_requirements', 'career_pathways',
    'career_pathways_other']);


programModelForm('programModelGreenBuildingForm', ['green_building_council']);

programModelForm('programModelProgramDesignForm', [
    'policy_council', 'substance_abuse_policy', 'financial_literacy_skills',
    'pse_bridging_activities', 'pse_bridging_activities_other']);
